/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Input,
  Form,
  message,
  Spin,
  Empty,
  Button,
  Checkbox,
} from "antd";
import RateCharges from "../../components/NewRateEngine/NewRateCard/RateCharges";
import QuotationForm from "../LeadGenerationCP/NewRateCard/QuotationForm";
import API from "../../api";
import urls from "../../api/urls";
import { useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { capitaliseWithHyphen, spaceBeforeCapital } from "../../utils";
import moment from "moment";
import { EditOutlined, SaveOutlined } from "@ant-design/icons";
import RateCardMatrix from "../../views/DynamicRateCard/DynamicRateCardMatrix";
import validateRateCard from "../../views/DynamicRateCard/rateUtil";
import constants from "../../constants/constants";
import { zoneAPI } from "../../api/RateCardApi";
const { GET_ALL_CHARGES, GET_ALL_CALCULATION_BASIS, PATCH_RATE_CARD_BY_ID } =
  urls;
const { ROLES } = constants;
const { CP_ADMIN } = ROLES;

const CashRateCard = ({
  data,
  edit = false,
  getInitialData = () => {},
  customerId = null,
  rateCardType = null,
  showValueChangedPercentage = false,
  showAddRateMatrix = true,
  showInvoiceType = true,
  showComittedBusiness = false,
  showHighLight,
}) => {
  const currentEnv = process.env.REACT_APP_ENV;
  const history = useLocation();
  let params = useParams();
  const dateFormat = "DD-MM-YYYY";
  const [form] = Form.useForm();
  const [rateMatrixData, setRateMatrixData] = useState({});
  const [rateChargesData, setRateChargesData] = useState([]);
  const [quotationRateCharges, setquotationRateCharge] = useState([]);
  const [quotationRateMatrixCash, setQuotationRateMatrixCash] = useState({});

  const [quotationData, setQuotationData] = useState({});
  const [loading, setLoading] = useState(false);
  const [calculationBasisList, setCalculationBasisList] = useState([]);
  const [defaultRateCharge, setDefaultRateCharge] = useState([]);
  const [actionEdit, setActionEdit] = useState(false);
  const [templateDetails, setTemplateDetails] = useState({});
  const [cpEdit, setCpEdit] = useState(false);
  const [rateCardError, setRateCardError] = useState([]);
  const [rateCardTypes, setRateCardTypes] = useState({});
  const [defaultZones, setDefaultZones] = useState([]);
  const [addRateMatrix, setAddRateMatrix] = useState(false);

  const cpRole = JSON.parse(localStorage.getItem("userinfo"))?.roles?.includes(
    CP_ADMIN
  );

  useEffect(() => {
    fetchInitialData();
  }, []);

  useEffect(() => {
    if (templateDetails?.charges) {
      setquotationRateCharge({
        current: templateDetails?.charges,
      });
    }

    if (
      templateDetails?.rates?.[0]?.rate &&
      Object.keys(templateDetails?.rates?.[0]?.rate).length > 0
    ) {
      setAddRateMatrix(true);
      setQuotationRateMatrixCash(templateDetails?.rates?.[0]?.rate);
    } else {
      setAddRateMatrix(false);
    }
  }, [templateDetails]);

  const fetchInitialData = async () => {
    try {
      const [chargeRes, calcRes] = await Promise.all([
        API.Api(GET_ALL_CHARGES).get(),

        API.Api(GET_ALL_CALCULATION_BASIS).get(),
      ]);

      if (chargeRes?.status) {
        setDefaultRateCharge(
          chargeRes.response.data.map(({ _id, head, calculationBasis }) => ({
            _id,
            head,
            key: _id,
            calculationBasis,
            global: true,
          }))
        );
      } else {
        message.error(
          chargeRes?.response?.data?.message || "Can't fetch rate charges."
        );
      }

      if (calcRes?.status) {
        setCalculationBasisList(
          calcRes.response?.data?.map((item) => ({
            label: spaceBeforeCapital(item?.name),
            value: item?.name,
            unit: item?.unit,
          }))
        );
      }
    } catch (error) {
      message.error("Failed to fetch initial data.");
    }
  };

  // const showApprove =
  //   quotationData?.approvalStatus?.toUpperCase() === "PENDING" &&
  //   history?.state?.type === "ho-lead";

  const showApprove =
    params?.status?.toUpperCase() === "PENDING" &&
    history?.state?.type === "ho-lead";

  const quotationId = params?.cpLeadQuotation;

  useEffect(() => {
    //if (quotationId) {
    getQuotationDetail();
    //}
  }, [data]);

  const getQuotationDetail = () => {
    // const companyId =
    //   JSON.parse(localStorage.getItem("selectedCompany"))?.key || null;
    // const cashQuotationName =
    //   JSON.parse(localStorage.getItem("selectedCompany"))?.cashQuotationName ||
    //   null;
    // let res =
    //   currentEnv === "qa"
    //     ? await API.Api(
    //         GET_RATE_CARD_QUOTATION + cashQuotationName + "?includeOld=" + false
    //       ).get()
    //     : await API.Api(GET_RATECARD_BY_USER + companyId).get();

    // if (res?.status) {
    //   setLoading(false);

    setQuotationData(data);

    form.setFieldsValue({
      // fromDate: moment(data?.fromDate),
      // toDate: moment(data?.toDate),
      fromDate: data?.fromDate?.split("")?.includes("T")
        ? moment(data?.fromDate)
        : data?.fromDate,
      toDate: data?.toDate?.split("")?.includes("T")
        ? moment(data?.toDate)
        : data?.toDate,
      //fromDate: moment(data?.fromDate).format("DD/MM/YYYY"),
      // toDate: moment(data?.toDate).format("DD/MM/YYYY"),
      billingCycle: capitaliseWithHyphen(data?.billingCycle),
      invoiceType: capitaliseWithHyphen(data?.invoiceType),
      type: data?.type,
      commitedBusiness: data?.commitedBusiness,
    });
    setquotationRateCharge({
      current: data?.charges,
      past: data?.charges_old || null,
    });
    // data?.rates?.forEach((item) => {
    //   switch (item?.type) {
    //     case "ACCOUNT":
    //       setQuotationRateMatrixAccount(item?.rate);
    //       break;
    //     case "CASH":
    //       setQuotationRateMatrixCash(item?.rate);
    //       break;
    //     default:
    //       break;
    //   }
    // });
    if (
      data?.rates?.[0]?.rate &&
      Object.keys(data?.rates?.[0]?.rate).length > 0
    ) {
      setAddRateMatrix(true);
    } else {
      setAddRateMatrix(false);
    }

    setQuotationRateMatrixCash(data?.rates?.[0]?.rate);
  };

  const setRateCharge = (data1) => {
    setRateChargesData(data1);
  };
  const saveRateCard = async (val) => {
    // const vals = await form1.validateFields();
    // console.log(vals);
    //console.log(rateMatrixData, "rateMatrixData");
    //console.log(defaultZones, "defaultZones", rateCardTypes);

    let travelMode = rateCardTypes?.travelMode?.[0];
    let docType = rateCardTypes?.docType?.[0];
    let shippingType = rateCardTypes?.shippingType?.[0];
    const allZones =
      rateMatrixData?.[docType]?.[travelMode]?.[shippingType]?.[0];
    const customZones = Object.keys(allZones || {}).filter(
      (key) => !defaultZones.includes(key)
    );
    let payloadRates = [];
    if (addRateMatrix) {
      payloadRates = [
        {
          rate: rateMatrixData || {},
          type:
            rateCardType?.toUpperCase() ||
            quotationData?.rates?.[0]?.type?.toUpperCase(),
        },
      ];
    }
    if (actionEdit) {
      if (addRateMatrix) {
        const rateCardError = validateRateCard(rateMatrixData, rateCardTypes);
        setRateCardError(rateCardError);
        if (rateCardError.length > 0) {
          message.error("Please fill the zero value in the matrix");
          return;
        }
      }
    }
    setLoading(true);

    try {
      const payload = {
        ...val,

        toDate: val?.toDate ? moment(val.toDate) : null,
        fromDate: val?.fromDate ? moment(val.fromDate) : null,

        rates: payloadRates,
        charges: rateChargesData?.map((item) => ({
          chargesHead: item?.head,
          rateType: item?.chargeType,
          pricingType: item?.pricingType,
          appliesOn: item?.appliesOn,
          calculationBasis: item?.calculationBasis,
          rate:
            item?.pricingType === "SLAB" || item?.chargeType === "PERCENTAGE"
              ? null
              : parseFloat(item?.rate),
          name: item?.pricingType === "FIXED" ? null : item?.slabId,
          percentage:
            item?.pricingType === "SLAB" || item?.chargeType === "VALUE"
              ? null
              : parseFloat(item?.percentage),
        })),
      };

      let res = await API.Api(
        PATCH_RATE_CARD_BY_ID + quotationData?.rateCardId
      ).patch(payload);
      if (res?.status) {
        if (cpRole) {
          setCpEdit(!cpEdit);
        } else {
          setActionEdit(!actionEdit);
        }
        if (customZones.length > 0 && addRateMatrix) {
          const payload = {
            zones: customZones,
            rateCardId: quotationData?.rateCardId,
          };
          const headers = {
            parent: localStorage.getItem("userinfo")?.roles?.includes("CP")
              ? "CP"
              : "HO",
          };
          const resZone = await zoneAPI.patchZoneRateCard(payload, headers);
          if (!resZone?.status) {
            message.error(
              resZone?.response?.data?.message || "Internal server error."
            );
          }
        }
        getInitialData();
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        setLoading(false);
        message.success("Ratecard updated successfully");
      } else {
        setLoading(false);
        message.error(res?.response?.data?.message || "Internal server error.");
      }
    } catch (errorInfo) {
      //console.log(errorInfo);
      setLoading(true);
      window.scrollTo({ top: 10, left: 0, behavior: "smooth" });
    }
  };

  // const validateRateCard = (rateMatrix) => {
  //   const errors = [];
  //   outerLoop: for (const doc of rateCardTypes?.docType || []) {
  //     for (const travelMode of rateCardTypes?.travelMode || []) {
  //       for (const shipping of rateCardTypes?.shippingType || []) {
  //         const innerTemp = rateMatrix?.[doc]?.[travelMode]?.[shipping];
  //         if (Array.isArray(innerTemp)) {
  //           for (const item of innerTemp) {
  //             const hasZero = Object.entries(item).some(
  //               ([key, value]) => key !== "minValue" && value == 0
  //             );
  //             if (hasZero) {
  //               errors.push({ doc, travelMode, shipping });
  //               break outerLoop; // Exit all loops immediately
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  //   setRateCardError(errors);
  //   return errors;
  // };

  const setData = (data) => {
    setTemplateDetails(data);
  };

  return (
    <div className="master-main-container p-1">
      {/* <Heading
        title={quotationData?.name}
        id={1}
        //navigateTo={("profile", 2)}
      /> */}

      <Spin spinning={loading}>
        {quotationData?.name ? (
          <Form
            className="global-form"
            layout="vertical"
            form={form}
            scrollToFirstError={{
              behavior: "smooth",
              block: "center",
              inline: "center",
            }}
            onFinish={saveRateCard}
          >
            {(edit ||
              (cpRole && quotationData?.type?.toUpperCase() === "CASH")) && (
              <div className="space-between">
                <p>{quotationData?.name}</p>

                {(edit && actionEdit) || (cpRole && cpEdit) ? (
                  <Button
                    className="save-btn"
                    icon={<SaveOutlined />}
                    onClick={() => form.submit()}
                  >
                    SAVE
                  </Button>
                ) : (
                  <Button
                    icon={<EditOutlined />}
                    onClick={() => {
                      if (edit) setActionEdit(true);
                      if (cpRole) setCpEdit(true);
                    }}
                  >
                    Edit
                  </Button>
                )}
              </div>
            )}

            <Row className="global-form-row p-1" gutter={20}>
              {actionEdit ? (
                <QuotationForm
                  hideCommitedBusiness={true}
                  getTemplateDetails={(data) => setData(data)}
                  //getTemplateDetails={(data) => setTemplateDetails(data)}
                />
              ) : (
                <>
                  <Col span={2} />
                  <Col className="form-inputs" span={5}>
                    <Form.Item name="fromDate" label="Start Date">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                  <Col className="form-inputs" span={5}>
                    <Form.Item name="toDate" label="End Date">
                      <Input disabled />
                    </Form.Item>
                  </Col>

                  <Col className="form-inputs" span={5}>
                    <Form.Item name="billingCycle" label="Billing Cycle">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                  {showInvoiceType && (
                    <Col className="form-inputs" span={5}>
                      <Form.Item name="invoiceType" label="Invoice Type">
                        <Input disabled />
                      </Form.Item>
                    </Col>
                  )}
                  {showComittedBusiness && (
                    <Col className="form-inputs" span={5}>
                      <Form.Item
                        name="commitedBusiness"
                        label="Commited Business"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                  )}
                  <Col span={2} />
                </>
              )}
            </Row>
            <div>
              <RateCharges
                rateCharge={setRateCharge}
                //quotationRateCharge={quotationRateCharges}
                defaultRateCharge={defaultRateCharge}
                calculationBasisList={calculationBasisList}
                actionEdit={
                  actionEdit ||
                  (cpEdit && quotationData?.type?.toUpperCase() === "CASH")
                }
                userId={quotationData?.userId}
                quotationRateCharge={quotationRateCharges}
              />
              {showAddRateMatrix && (
                <div className="d-flex ml-2 mt-2">
                  <Checkbox
                    onChange={(e) => setAddRateMatrix(e.target.checked)}
                    className="custom-checkbox-add-rate-matrix"
                    checked={addRateMatrix}
                    disabled={!actionEdit}
                  >
                    <span className="f-18 fw-500">Add RateMatrix</span>
                  </Checkbox>
                </div>
              )}
              {addRateMatrix && (
                // <CashRate
                //   rateMatrixData={setRateMatrix}
                //   quotationRateMatrix={quotationRateMatrixCash}
                //   type={"viewCash"}
                //   actionEdit={actionEdit}
                // />
                <RateCardMatrix
                  //getData={quotationRateMatrixCash}
                  showValueChangedPercentage={showValueChangedPercentage}
                  getData={
                    templateDetails?.rates?.[0]?.rate || quotationRateMatrixCash
                  }
                  setMatrixData={(data) => setRateMatrixData(data)}
                  actionEdit={actionEdit}
                  customerId={customerId}
                  rateCardType={rateCardType}
                  setRateCardOptionTypes={(data) => setRateCardTypes(data)}
                  rateCardError={rateCardError}
                  getAllDefaultZones={(data) => setDefaultZones(data)}
                  showHighLight={showHighLight}
                />
              )}
            </div>
          </Form>
        ) : (
          <div className="no-data-prresnt">
            No cash rate card has been configured, please contact to HO team.
          </div>
        )}
      </Spin>
    </div>
  );
};
export default CashRateCard;
